const WHITE_COLOR_FORMATS = ['#ffffff', '#fff', '#ffffffff', 'rgb(255, 255, 255)'];

const isWhiteColor = (color) => {
  if (!color || typeof color !== 'string') return false;
  return WHITE_COLOR_FORMATS.includes(color.toLowerCase());
};

export default isWhiteColor;
